var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2A5ADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.468 4.844 11.936 4l1.468.844 4 2.312L18.872 8v8l-1.468.844-3.964 2.312-1.467.844-1.468-.844-4.037-2.312L5 16V8l1.468-.844 4-2.312ZM7.936 9.688v4.624l4 2.312 4-2.312V9.688l-4-2.312-4 2.312Z",
    fill: "#fff"
  })));
};
export { SvgLink as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiMyQTVBREEiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC40Njc5IDQuODQ0MDRMMTEuOTM1OCA0TDEzLjQwMzcgNC44NDQwNEwxNy40MDM3IDcuMTU1OTZMMTguODcxNiA4VjE2TDE3LjQwMzcgMTYuODQ0TDEzLjQ0MDQgMTkuMTU2TDExLjk3MjUgMjBMMTAuNTA0NiAxOS4xNTZMNi40Njc4OSAxNi44NDRMNSAxNlY4TDYuNDY3ODkgNy4xNTU5NkwxMC40Njc5IDQuODQ0MDRaTTcuOTM1NzggOS42ODgwN1YxNC4zMTE5TDExLjkzNTggMTYuNjIzOUwxNS45MzU4IDE0LjMxMTlWOS42ODgwN0wxMS45MzU4IDcuMzc2MTVMNy45MzU3OCA5LjY4ODA3WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";